import { render, staticRenderFns } from "./panelStatics.vue?vue&type=template&id=0010645e&scoped=true&"
import script from "./panelStatics.vue?vue&type=script&lang=js&"
export * from "./panelStatics.vue?vue&type=script&lang=js&"
import style0 from "./panelStatics.vue?vue&type=style&index=0&id=0010645e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010645e",
  null
  
)

export default component.exports